<template>
  <div>
  </div>
</template>

<script>
export default {
  name: 'component-footer',
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style>
</style>